// The image a card shows for a library entry. Writing is drawn, not
// photographed: articles always get their motif (motifPlaceholder.ts), so the
// card is given no image. Their `thumbnail` stays in library.json for the
// other things that read it (the site guide's chat cards).
export function cardImage(entry) {
  if (!entry || entry.type === 'article') return undefined;
  return entry.thumbnail;
}
